import React from 'react'
import { Field } from '../../../form'
import { Translation } from 'react-i18next'
import MenuItem from '@material-ui/core/MenuItem'
import FontAwesome from 'react-fontawesome'

const LightEntreSelectField = React.memo(
  ({ classes, lightEntreList, control, disabled, onChange }) => {
    return (
      <Translation>
        {(t) => (
          <Field
            name="offer_to"
            inputType="select"
            className={classes.select}
            label={t('employer.workshifts.fld1')}
            control={control}
            disabled={disabled}
            onChange={onChange}
          >
            {/* <MenuItem value="">{t('employer.workshifts.value3')}</MenuItem> */}
            {createItems(lightEntreList)}
          </Field>
        )}
      </Translation>
    )
  }
)

function createItems(data) {
  return data.map((item, index) => (
    <MenuItem
      key={index}
      value={item.offered_entrepreneur_email + '-' + item.agreement_id}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <div>
          {item.firstname + ' ' + item.lastname + ' - ' + item.contract_name} (
          {item.salary_model})
        </div>
        <div style={{ marginLeft: '8px' }}>
          <a
            href={item.contract_path}
            download
            onClick={(e) => e.stopPropagation()} // Prevent triggering MenuItem select
          >
            <FontAwesome name="file-pdf-o" />
          </a>
        </div>
      </div>
    </MenuItem>
  ))
}

export default LightEntreSelectField
